import requestSuccessFailureHelper from '../utils/helpers/ReduxHelper';
import ApiClient from '../utils/apiClient';
import { COURTS } from '../utils/constants';

export default function getCourts(filters) {
  const { action: getCourtsAction } = requestSuccessFailureHelper(COURTS, () =>
    ApiClient.post('/api/v1/court/', {
      filters
    })
  );
  return dispatch => {
    dispatch(getCourtsAction());
  };
}



// WEBPACK FOOTER //
// ./src/actions/courtsActions.js